<template>
    <b-modal v-model="show" size="lg" title="КАТТА КИЧИКЛИГИ ТУЗАТИШ ПАРАМЕТРИ" class="cadastre-building"
             :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
                        <v-select
                                label="label"
                                v-model="data.province"
                                :filterable="false"
                                :options="provinces"
                                @search="onProvinceSearch"
                                @search:focus="onProvinceFocus"
                                @change="onChangeProvince"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.data.province.id.$error">
                            {{$t("realEstate.validation.province")}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("realEstate.field.region")}} </label>
                        <treeselect class="form-control"
                                    v-model="data.regionIds"
                                    placeholder="Танланг..."
                                    :options="regions"
                                    :multiple="true"
                                    :noOptionsText="treeEmptyOptionText"
                        ></treeselect>
                    </div>
                    <div class="form-group">
                        <label>Тузатиш тури <span class="red">*</span></label>
                        <v-select
                                label="name"
                                v-model="data.fixSizeType"
                                :filterable="false"
                                :options="fixSizeTypes"
                                @search="onFixSizeTypeSearch"
                                @search:focus="onFixSizeTypeFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right"  @click="save" v-if="!processing && hasPermission('SETTINGS_BUILDING_CADASTRE_FIX_SIZE_ADD')">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="show=!show">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {required, minLength} from 'vuelidate/lib/validators';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: "CadastreFixSizeAddModal",
        components: {
            'b-modal': bModal,
            Treeselect
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                data: this.initData(),
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                filterFixSizeType: initFilterModel(),
                regions: [],
                provinces: [],
                fixSizeTypes: []
            }
        },
        validations() {
            return {
                data: {
                    province: {
                        id: {
                            required
                        }
                    },
                    regionIds: {
                        required: required,
                        minLength: minLength(1)
                    }
                }
            }
        },
        computed: {
            treeEmptyOptionText() {
                return this.$t("messages.combo.empty")
            }
        },
        methods: {
            initData() {
                return {
                    code: '',
                    name: '',
                    nameRu: '',
                    province: null,
                    regionIds: [],
                    fixSizeType: null,
                    averagePrice: 0,
                    value: 0,
                    items: []
                };
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;

                this.processing = true;
                this.$http.post('/cadastre/fix-size', this.data)
                    .then(res => {
                        const response = res.data;
                        if (response && response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('onCadastreFixSizeChanged', response);
                        }
                        vm.processing = false;
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            getAsMaps(result) {
                if (result && result.data && result.data.length > 0) {
                    return result.data.map(d =>({id: d.id, label: d.name}))
                }
                return [];
            },
            onProvinceFocus() {
                this.provinces = [];
                this.filterProvince.search = '';
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onChangeProvince() {
                this.regions = [];
                this.filterRegion.provinceId = (this.data.province && this.data.province.id) ? this.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            onFixSizeTypeSearch(searchTxt, loading) {
                loading(true);
                this.fixSizeTypes = [];
                this.filterFixSizeType.search = searchTxt;
                this.$http.post('cadastre/fix-size-type/list', this.filterFixSizeType)
                    .then(res => {
                        this.fixSizeTypes = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onFixSizeTypeFocus() {
                this.fixSizeTypes = [];
                this.filterFixSizeType.search = '';
                this.$http.post('cadastre/fix-size-type/list', this.filterFixSizeType)
                    .then(res => {
                        this.fixSizeTypes = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.filterFixSizeType.page.size = 1000;

            this.$eventBus.$on('showCadastreFixSizeAddModal', (data) => {
                if (!data) {
                    this.data = this.initData()
                }
                this.show = true;
            });
        }

    }
</script>

<style scoped>

</style>